"use client";

import { Shield, ChevronRight, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function LayananOrganisasiHero() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const features = [{
    label: "STRUKTUR HIERARKI",
    icon: Shield
  }, {
    label: "MANDAT KOMANDO",
    icon: Shield
  }, {
    label: "UNIT FUNGSIONAL",
    icon: Shield
  }];
  return <section data-section-id="1858" id="layananorganisasihero" ref={sectionRef} className="relative min-h-[80vh] flex items-center overflow-hidden bg-[#111111] text-white py-24 md:py-32">
      {}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-[#B30000]/10 rounded-lg blur-3xl" />
        <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-[#D4AF37]/5 rounded-lg blur-3xl" />
        <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
      }} />
      </div>

      <div className="relative container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          {}
          <div className="lg:col-span-7 transition-all duration-1000 ease-out" style={{
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? "translateX(0)" : "translateX(-20px)"
        }}>
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-8 bg-[#B30000]" />
              <span className="text-[#D4AF37] font-bold tracking-[0.2em] text-xs uppercase">
                Zona Pemuda Pancasila
              </span>
            </div>

            <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold leading-[1.1] mb-8 tracking-tight">
              Layanan <span className="text-[#B30000]">Organisasi</span> <br />
              Profesional & Terpadu
            </h1>

            <p className="text-lg md:text-xl text-gray-400 max-w-2xl mb-10 leading-relaxed">
              Mendukung integritas dan sinergi struktural melalui sistem layanan informasi yang transparan, akuntabel, dan berorientasi pada pengabdian masyarakat.
            </p>

            <div className="flex flex-wrap gap-4 mb-12">
              <Button asChild size="lg" className="bg-[#B30000] hover:bg-[#8a0000] text-white border-none rounded-md px-8 h-14 font-bold transition-transform hover:scale-[1.02]">
                <Link to="/OrganizationStructurePage">
                  Lihat Struktur <ChevronRight className="ml-2 size-4" />
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="border-white/20 text-white hover:bg-white/5 rounded-md px-8 h-14 font-bold">
                <Link to="/ContactPage">Hubungi Kami</Link>
              </Button>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 pt-10 border-t border-white/10">
              {features.map((feature, i) => <div key={i} data-index={i} className="flex items-center gap-3 group cursor-default">
                  <div className="p-2 rounded-md bg-white/5 group-hover:bg-[#B30000]/20 transition-colors">
                    <feature.icon className="size-5 text-[#D4AF37]" />
                  </div>
                  <span className="text-xs font-bold tracking-wider text-gray-300 group-hover:text-white transition-colors">
                    {feature.label}
                  </span>
                </div>)}
            </div>
          </div>

          {}
          <div className="lg:col-span-5 relative transition-all duration-1000 ease-out delay-300" style={{
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? "translateY(0)" : "translateY(20px)"
        }}>
            <div className="relative z-10 aspect-[4/5] rounded-lg overflow-hidden border border-white/10 shadow-2xl">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/organization_services_hero.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/organization_services_hero.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/organization_services_hero.webp-wvc-sizes" alt="Layanan Organisasi Pemuda Pancasila" className="w-full h-full object-cover" loading="lazy" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#111111] via-transparent to-transparent opacity-60" />
              
              <div className="absolute bottom-6 left-6 right-6 p-6 bg-black/40 backdrop-blur-md rounded-lg border border-white/10">
                <p className="text-[#D4AF37] text-xs font-bold mb-2 uppercase tracking-widest">Update Sistem</p>
                <h3 className="text-lg font-bold mb-3">Integrasi Data Nasional 2024</h3>
                <Link to="/NewsPage" className="inline-flex items-center text-sm font-bold text-white hover:text-[#B30000] transition-colors">
                  Baca Selengkapnya <ArrowRight className="ml-2 size-4" />
                </Link>
              </div>
            </div>

            {}
            <div className="absolute -top-4 -left-4 w-24 h-24 border-t-2 border-l-2 border-[#D4AF37] rounded-tl-lg pointer-events-none" />
            <div className="absolute -bottom-4 -right-4 w-24 h-24 border-b-2 border-r-2 border-[#B30000] rounded-br-lg pointer-events-none" />
          </div>
        </div>
      </div>
    </section>;
}